module.exports = __webpack_public_path__ + "static/media/hideIcon.c5fa9ee8.svg";